// extracted by mini-css-extract-plugin
module.exports = {"root":"Tabs_root__1743r","tab":"Tabs_tab__3NTuU","tabActive":"Tabs_tabActive__hU4hL"};